import { IconsType } from 'components/Icon';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

interface GradientColors {
    from: string;
    to: string;
}

interface IconData {
    icon: IconsType;
    className: string;
}

export const getReferAndEarnGradient = (theme: Theme): GradientColors => {
    return {
        from: theme.palette.referAndEarnGradient[400],
        to: theme.palette.referAndEarnGradient[500],
    };
};

export const getReferAndEarnIcon = (classes: Record<string, string>): IconData => {
    return {
        icon: IconsType.refer_and_earn,
        className: classes.referAndEarnIcon,
    };
};
